export const KEYS = {
  ALT: 'Alt / ⌥',
  MOD: 'Ctrl / ⌘',
  SHIFT: 'Shift',
  SLASH: '/',
  UP: 'Up',
  DOWN: 'Down',
};

export const SHORTCUT_KEYS = [
  { id: 1, label: 'OPEN_ACTION_CENTER', displayKeys: ['F2'], keySet: ['F2'] },
  {
    id: 2,
    label: 'CYCLE_LANDMARKS',
    displayKeys: ['F6', KEYS.SLASH, KEYS.SHIFT, 'F6'],
    keySet: ['F6', 'Shift+F6'],
  },
  {
    id: 3,
    label: 'CLAIM_NEXT_CONVERSATION',
    displayKeys: [KEYS.ALT, KEYS.SHIFT, 'G'],
    keySet: ['Alt+Shift+KeyG'],
  },
  {
    id: 4,
    label: 'ASSIGN_CURRENT_TO_ME',
    displayKeys: [KEYS.ALT, KEYS.SHIFT, 'U'],
    keySet: ['Alt+Shift+KeyU'],
  },
  {
    id: 5,
    label: 'RETURN_CURRENT_TO_QUEUE',
    displayKeys: [KEYS.ALT, KEYS.SHIFT, 'Q'],
    keySet: ['Alt+Shift+KeyQ'],
  },
  {
    id: 6,
    label: 'SELECT_CONVERSATION_BY_NUMBER',
    displayKeys: [KEYS.ALT, '1–9', KEYS.SLASH, KEYS.ALT, '0'],
    keySet: ['Alt+Digit1', 'Alt+Digit0'],
  },
  {
    id: 7,
    label: 'SELECT_QUEUE_BY_NUMBER',
    displayKeys: [KEYS.ALT, KEYS.SHIFT, '1–4'],
    keySet: ['Alt+Shift+Digit1'],
  },
  {
    id: 8,
    label: 'RESOLVE_AND_NEXT',
    displayKeys: [KEYS.MOD, KEYS.ALT, 'E'],
    keySet: ['$mod+Alt+KeyE'],
  },
  {
    id: 9,
    label: 'ADD_ATTACHMENT',
    displayKeys: [KEYS.MOD, KEYS.ALT, 'A'],
    keySet: ['$mod+Alt+KeyA'],
  },
  {
    id: 10,
    label: 'TOGGLE_PUBLIC_PRIVATE',
    displayKeys: [KEYS.ALT, KEYS.SHIFT, 'T'],
    keySet: ['Alt+Shift+KeyT'],
  },
  {
    id: 11,
    label: 'SUMMARIZE_CONVERSATION',
    displayKeys: [KEYS.ALT, KEYS.SHIFT, 'S'],
    keySet: ['Alt+Shift+KeyS'],
  },
  {
    id: 12,
    label: 'DESCRIBE_IMAGE',
    displayKeys: [KEYS.ALT, KEYS.SHIFT, 'I'],
    keySet: ['Alt+Shift+KeyI'],
  },
  {
    id: 13,
    label: 'OPEN_ACCESSIBILITY',
    displayKeys: [KEYS.ALT, KEYS.SHIFT, 'A'],
    keySet: ['Alt+Shift+KeyA'],
  },
  {
    id: 14,
    label: 'FOCUS_CONVERSATION_LIST',
    displayKeys: [KEYS.ALT, KEYS.SHIFT, 'C'],
    keySet: ['Alt+Shift+KeyC'],
  },
  {
    id: 15,
    label: 'FOCUS_REPLY',
    displayKeys: [KEYS.ALT, KEYS.SHIFT, 'R'],
    keySet: ['Alt+Shift+KeyR'],
  },
  {
    id: 16,
    label: 'ANNOUNCE_CONVERSATION_BRIEFING',
    displayKeys: [KEYS.ALT, KEYS.SHIFT, 'L'],
    keySet: ['Alt+Shift+KeyL'],
  },
];
